import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import copy from 'copy-to-clipboard';
import { alterSnackbar } from "~/data/actions/siteActions";
import TwoColPaperExplainer from '~/Common-Objects/DomainManagement/Components/TwoColPaperExplainer'
export default function DMARCSettings({ domainId, setFlowStep, domainProvider, domainRecords, setDomainRecords, subDomain = "" }) {
    const site = useSelector((state) => state.siteMaster)
    const dispatch = useDispatch();
    const copyVal = (val) => {
        copy(val);
        dispatch(alterSnackbar(true, "Copied to clipboard"));
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setFlowStep("trackingSettings");
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const newRecordsData = domainRecords.filter(record => record.type == "DMARC").map(record => {
        
        let finalHost = record.host;
        if (subDomain) {
            finalHost = finalHost + "." + subDomain;
        }
        
        return {
            type: {
                headerValue: 'Type',
                value: <SquareChip>{record.recordType}</SquareChip>
            },
            host: {
                headerValue: 'Host',
                value: <TextInput readOnly={true} value={finalHost} iconRight={<Icon name="copy" onClick={() => { copyVal(finalHost) }} />} />
            },
            value: {
                headerValue: 'Value/Target',
                value: <TextInput readOnly={true} value={record.value} iconRight={<Icon name="copy" onClick={() => { copyVal(record.value) }} />} />
            }
        }
    })

    return (
        <>
            <div>{i18n.t('company:domains.domainManagement.makeSureRecord', { provider: domainProvider?.label })}</div>
            <DataTable1
                tableData={newRecordsData}
                loadingData={[]}
                dataUpdater={() => { }}
                width='100%'
                pageSize='100'
                hasCheckBoxes='no'
                sortedColumn={""}
                sortedDirection={""}
                className='mar-b20'
            />

            <Button
                text={i18n.t('company:domains.domainManagement.continue')}
                iconRight={<Icons icon="arrowRight" />}
                className="button-primary"
                onClick={() => {
                    setFlowStep("trackingSettings");
                }}
            />

            <TwoColPaperExplainer
                className="mar-t20 mar-b5"
                title={i18n.t('company:domains.domainManagement.dmarcExplainerTitle')}
                content={i18n.t('company:domains.domainManagement.dmarcExplainerContent')}
            />

        </>



    )
}